<div class="master-div">
    <div class="maindiv">
        <div>
            <div class="rectangle-copy">
                <img src="assets/image/se-logow.svg" alt="" style="margin-left:10px;margin-top: 10px;" height="35" width="150">
            </div>
            <div>
                <img src="assets/image/bitmap.png" alt="" style="width: 100%;" height="120" width="10">
            </div>
        </div>
        <div class="scroll clearfix">
            <div class="topdiv">
                <h4>Industry Services T&C</h4>
                <div style="float:left;width: 50%;">
                    <div class="rectangle">
                        <img src="assets/image/ic-pdf.png" alt="" style="margin-left:10px;" height="35" width="26">
                        <a class="anchor" href="assets/Industry_Services_Portal_Terms.pdf" target="_blank" rel="noopener noreferrer">Industry Services Terms&Cond_EN</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="scroll">
            <div class="topdiv">
                <h4>Industry Services Privacy Policy</h4>
                <div style="float:left;width: 50%;">
                    <div class="rectangle">
                        <img src="assets/image/ic-pdf.png" alt="" style="margin-left:10px;" height="35" width="26">
                        <a class="anchor" href="assets/Industry_Services_Portal_Privacy_Policy.pdf" target="_blank" rel="noopener noreferrer">Industry Services Privacy&Policy_EN</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="rect-bottom">
        </div>
    </div>
</div>